exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-bread[data-v-9c004618]{margin-top:8px;margin-left:10px;font-size:20px;font-weight:700!important}.PropertyTitle[data-v-9c004618] .el-collapse-item__header{font-size:18px!important;font-weight:700!important;padding:0 0 0 10px;background-color:#f0f8ff}", ""]);

// exports
